/** @jsx jsx */
import { jsx, Box, Styled } from "theme-ui"
import { Tabs, TabList, Tab, TabPanels, TabPanel } from "@reach/tabs"

import { Container } from "components/layout"
import LocalizedButton from "components/localized-button"

import useLocale from "hooks/use-locales"

import "@reach/tabs/styles.css"

const ProgramTabs = () => {
  const { t } = useLocale()

  const styles = {
    nav: {
      alignItems: ["flex-start", "flex-start", "flex-end"],
      background: "none",
      display: "flex",
      flexDirection: ["column", "column", "row"],
      justifyContent: "space-between",
    },
    navItem: {
      bg: "dark",
      border: "none",
      borderTopLeftRadius: "default",
      borderTopRightRadius: "default",
      borderBottomLeftRadius: ["default", "default", 0],
      borderBottomRightRadius: ["default", "default", 0],
      color: "background",
      display: "block",
      my: [1, 1, 0],
      py: [2, 2, 3],
      px: 3,
      width: ["100%", "100%", "auto"],
      transition: "all 150ms ease",
      "&[data-selected]": {
        bg: "primary",
        "&:hover": {
          bg: "muted",
          color: "dark",
        },
      },
      "&:hover, &[data-selected]:hover": {
        bg: "muted",
        color: "dark",
      },
    },
    panels: {
      bg: "primary",
      color: "background",
      py: 3,
    },
  }

  return (
    <Box sx={{ my: 5 }}>
      <Styled.h2 sx={{ textAlign: "center", mb: 4, color: "primary" }}>
        Programs
      </Styled.h2>
      <Tabs>
        <Container>
          <TabList sx={styles.nav}>
            <Tab sx={styles.navItem}>{t("menu.programs.abuse")}</Tab>
            <Tab sx={styles.navItem}>{t("menu.programs.youth")}</Tab>
            <Tab sx={styles.navItem}>{t("menu.programs.support")}</Tab>
            <Tab sx={styles.navItem}>{t("menu.programs.resource")}</Tab>
            <Tab sx={styles.navItem}>{t("menu.programs.development")}</Tab>
          </TabList>
        </Container>
        <TabPanels sx={styles.panels}>
          <Container>
            <TabPanel>
              <Styled.h3 sx={{ color: "background" }}>
                {t("menu.programs.abuse")}
              </Styled.h3>
              <Styled.p>{t("programs.abuse.text")}</Styled.p>
              <Styled.p>
                <LocalizedButton variant="light" to="/programs/against-abuse">
                  {t("programs.abuse.button")}
                </LocalizedButton>
              </Styled.p>
            </TabPanel>
            <TabPanel>
              <Styled.h3 sx={{ color: "background" }}>
                {t("menu.programs.youth")}
              </Styled.h3>
              <Styled.p>{t("programs.youth.text")}</Styled.p>
              <Styled.p>
                <LocalizedButton variant="light" to="/programs/child-youth">
                  {t("programs.youth.button")}
                </LocalizedButton>
              </Styled.p>
            </TabPanel>
            <TabPanel>
              <Styled.h3 sx={{ color: "background" }}>
                {t("menu.programs.support")}
              </Styled.h3>
              <Styled.p>{t("programs.support.text")}</Styled.p>
              <Styled.p>
                <LocalizedButton variant="light" to="/programs/support-services">
                  {t("programs.support.button")}
                </LocalizedButton>
              </Styled.p>
            </TabPanel>
            <TabPanel>
              <Styled.h3 sx={{ color: "background" }}>
                {t("menu.programs.resource")}
              </Styled.h3>
              <Styled.p>{t("programs.resource.text")}</Styled.p>
              <Styled.p>
                <LocalizedButton variant="light" to="/programs/resource-referral">
                  {t("programs.resource.button")}
                </LocalizedButton>
              </Styled.p>
            </TabPanel>
            <TabPanel>
              <Styled.h3 sx={{ color: "background" }}>
                {t("menu.programs.development")}
              </Styled.h3>
              <Styled.p>{t("programs.development.text")}</Styled.p>
              <Styled.p>
                <LocalizedButton variant="light" to="/programs/community-development">
                  {t("programs.development.button")}
                </LocalizedButton>
              </Styled.p>
            </TabPanel>
          </Container>
        </TabPanels>
      </Tabs>
    </Box>
  )
}

export default ProgramTabs
